import { useState } from 'react';
import { useFile } from '../context/AppContext.jsx';
import FileUploadSection from './sections/FileUploadSection.jsx';
import FileInfoSection from './sections/FileInfoSection.jsx';
import FeaturesSection from './sections/FeaturesSection.jsx';
import WaypointListSection from './sections/WaypointListSection.jsx';

export default function LeftPanel() {
  const { currentFileData, currentInstallationData, currentWaypoints } = useFile();
  const [showFileInfo, setShowFileInfo] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);
  const [showWaypoints, setShowWaypoints] = useState(false);

  // Show sections based on AppContext state
  const hasFileData = currentFileData !== null;
  const hasInstallationData = currentInstallationData !== null;
  const hasWaypoints = currentWaypoints && currentWaypoints.length > 0;

  return (
    <aside className="bg-bg-secondary rounded-xl p-6 overflow-y-auto w-80 flex flex-col">
      <FileUploadSection
        onFileLoaded={() => setShowFileInfo(true)}
        onInstallationLoaded={() => setShowFeatures(true)}
        onWaypointsLoaded={() => setShowWaypoints(true)}
      />

      {(showFileInfo || hasFileData) && <FileInfoSection />}
      {(showFeatures || hasInstallationData) && <FeaturesSection />}
      {(showWaypoints || hasWaypoints) && <WaypointListSection />}
    </aside>
  );
}


